import type { CatalogMapPoint, CatalogNearMe, RelatedGeoArea } from './catalogsNearMe.types';

/**
 * Redux state slice for Auctions Near Me page
 *
 * Uses catalog-management API to fetch catalogs by geographic bounds.
 * Pagination and filtering are handled server-side.
 */
export type AuctionsNearMeSlice = {
    catalogIds: number[];
    catalogsNearMe: CatalogNearMe[];
    currentPage: number;
    error: string | null;
    /**
     * The URL's location could not be resolved to a real place, so the page is a soft 404.
     * Distinct from `error`: a bounds fetch that fails for a location we *did* resolve is a
     * transient failure, not an invalid URL, and must keep returning 200.
     */
    isLocationInvalid: boolean;
    loading: boolean;
    mapPoints: CatalogMapPoint[];
    otherPlaces: RelatedGeoArea[];
    totalPages: number;
    totalRecords: number;
    totalUniqueHouses: number;
};

export const defaultAuctionsNearMeSlice: AuctionsNearMeSlice = {
    catalogIds: [],
    catalogsNearMe: [],
    currentPage: 0,
    error: null,
    isLocationInvalid: false,
    loading: false,
    mapPoints: [],
    otherPlaces: [],
    totalPages: 0,
    totalRecords: 0,
    totalUniqueHouses: 0,
};
